module.exports = __webpack_public_path__ + "static/media/ethereum.4b4d164f.svg";